export function handleYoutubeIframeSizes() {
  const iframes = document.querySelectorAll(
    ".article-template__content iframe",
  );

  if (iframes.length === 0) return;

  setTimeout(() => {
    setIframeStyles(iframes);
  }, 200);

  // Also set styles on window resize in case of responsive iframes
  window.addEventListener("resize", () => {
    setIframeStyles(iframes);
  });
}

// Function to set styles for iframes adjust based on the video proportions
function setIframeStyles(iframes) {
  // check if its youtube iframe
  iframes.forEach((iframe) => {
    const src = iframe.getAttribute("src");
    if (src && src.includes("youtube.com")) {
      // Set width to 100% and height to maintain 16:9 aspect ratio
      iframe.style.width = "100%";
      console.log("iframe", iframe.offsetWidth);
      iframe.style.height = `${(iframe.offsetWidth * 9) / 16}px`;
    }
  });
}

export const initBlogShortcodes = () => {
  console.log("initBlogShortcodes called");
  //check if blog article container exists
  const blogArticle = document.querySelector(".js-shortcodes-root");
  if (!blogArticle) return;

  // Use the blogArticle element directly instead of document.currentScript
  var root = blogArticle;
  if (!root) return;

  // --- 1) Normalize editor wrappers to raw shortcodes ---
  var html = root.innerHTML;

  // Unwrap [highlight] and [/highlight] even if a <meta> is present
  html = html
    // [highlight] wrapped by <p><span>...</span></p> (with optional <meta> before it)
    .replace(
      /<p[^>]*>\s*<span[^>]*>\s*(?:<meta[^>]*>)?\s*\[highlight\]\s*<\/span>\s*<\/p>/gi,
      "[highlight]",
    )
    // [/highlight] wrapped by <p><span>...</span></p> (with optional <meta> before it)
    .replace(
      /<p[^>]*>\s*<span[^>]*>\s*(?:<meta[^>]*>)?\s*\[\/highlight\]\s*<\/span>\s*<\/p>/gi,
      "[/highlight]",
    )

    // Unwrap [product ...] wrapped by <p><span>...</span></p> (with optional <meta> before it)
    .replace(
      /<p[^>]*>\s*<span[^>]*>\s*(?:<meta[^>]*>)?\s*\[product\s+product_handle="([^"]+)"\s*\]\s*<\/span>\s*<\/p>/gi,
      '[product product_handle="$1"]',
    )

    // Unwrap [gallery ...] wrapped by <p><span>...</span></p> (with optional <meta> before it)
    .replace(
      /<p[^>]*>\s*<span[^>]*>\s*(?:<meta[^>]*>)?\s*\[gallery\s+images="([^"]+)"\s*\]\s*<\/span>\s*<\/p>/gi,
      '[gallery images="$1"]',
    )

    // Unwrap [accordion] and [/accordion] wrapped by <p><span>...</span></p> (with optional <meta> before it)
    .replace(
      /<p[^>]*>\s*<span[^>]*>\s*(?:<meta[^>]*>)?\s*\[accordion\s+title="([^"]+)"\s*\]\s*<\/span>\s*<\/p>/gi,
      '[accordion title="$1"]',
    )
    .replace(
      /<p[^>]*>\s*<span[^>]*>\s*(?:<meta[^>]*>)?\s*\[\/accordion\]\s*<\/span>\s*<\/p>/gi,
      "[/accordion]",
    )

    // Unwrap [quote ...] and [/quote] wrapped by <p><span>...</span></p> (with optional <meta> before it)
    .replace(
      /<p[^>]*>\s*<span[^>]*>\s*(?:<meta[^>]*>)?\s*\[quote\s+author="([^"]+)"\s*\]\s*<\/span>\s*<\/p>/gi,
      '[quote author="$1"]',
    )
    .replace(
      /<p[^>]*>\s*<span[^>]*>\s*(?:<meta[^>]*>)?\s*\[quote\]\s*<\/span>\s*<\/p>/gi,
      "[quote]",
    )
    .replace(
      /<p[^>]*>\s*<span[^>]*>\s*(?:<meta[^>]*>)?\s*\[\/quote\]\s*<\/span>\s*<\/p>/gi,
      "[/quote]",
    )

    // Also unwrap accordion shortcodes that are directly in <p> tags
    .replace(
      /<p[^>]*>\s*\[accordion\s+title="([^"]+)"\s*\]\s*([\s\S]*?)\s*\[\/accordion\]\s*<\/p>/gi,
      '[accordion title="$1"]$2[/accordion]',
    );

  // --- 2) General cleanup after unwrapping ---
  html = html
    // Remove any remaining <meta ...> tags
    .replace(/<meta[^>]*>/gi, "")
    // Clean up orphaned span tags (</span><span> patterns)
    .replace(/<\/span>\s*<span[^>]*>/gi, "")
    // Remove standalone span tags
    .replace(/<span[^>]*>/gi, "")
    .replace(/<\/span>/gi, "")
    // Collapse <p><span>content</span></p> → <p>content</p>
    .replace(
      /<p([^>]*)>\s*<span[^>]*>([\s\S]*?)<\/span>\s*<\/p>/gi,
      "<p$1>$2</p>",
    )
    // Remove empty paragraphs (including &nbsp;)
    .replace(/<p[^>]*>(?:\s|&nbsp;)*<\/p>/gi, "");

  // --- 3) Replace [highlight]...[/highlight] with your exact markup ---
  var highlightRe = /\[highlight\]([\s\S]*?)\[\/highlight\]/gi;
  html = html.replace(highlightRe, function (_, inner) {
    return `
        <section class="article-highlight mb-5 bg-beige border-rounded-stnd p-4 p-md-5 reset-last-pragaph-margin">
          <div class="rte">
            ${inner}
          </div>
        </section>
      `;
  });

  // --- 3b) Replace [quote author="..."]...[/quote] with quote markup (supports multiple instances) ---
  var quoteRe = /\[quote\s+author="([^"]+)"\]([\s\S]*?)\[\/quote\]/gi;
  html = html.replace(quoteRe, function (_, author, inner) {
    return `
        <blockquote class="article-quote my-5 ps-4 ps-md-5 p-4 h4 font-light">
          <div class="rte">
            <i>${inner}</i>
          </div>
          <div class="quote-author mt-3">${author}</div>
        </blockquote>
      `;
  });

  // Also handle [quote]...[/quote] without author (backward compatibility)
  var quoteReNoAuthor = /\[quote\]([\s\S]*?)\[\/quote\]/gi;
  html = html.replace(quoteReNoAuthor, function (_, inner) {
    return `
        <blockquote class="article-quote my-5 ps-4 ps-md-5 p-4 h4 font-light">
          <div class="rte">
            <i>${inner}</i>
          </div>
        </blockquote>
      `;
  });

  // --- 4) Replace [accordion title="..."]...[/accordion] with collapsible content ---
  var accordionRe =
    /\[accordion\s+title="([^"]+)"\]([\s\S]*?)\[\/accordion\]/gi;
  var accordionItems = [];
  var match;

  // Collect all accordion items
  while ((match = accordionRe.exec(html)) !== null) {
    var title = match[1];
    var content = match[2];
    var accordionId = "accordion-" + Math.random().toString(36).substr(2, 9);

    accordionItems.push(`
        <div class="accordion__item" id="${accordionId}">
          <div class="accordion__item-headline h5 mb-0" data-toggler-group="accordion" data-toggler-target="#${accordionId}" data-toggler-class="accordion__item--opened" role="button" aria-expanded="false" aria-controls="${accordionId}" >
            ${title}
          </div>
          <div class="accordion__item-content">
            <div>
               <div class="py-4">
                  ${content}
               </div>
            </div>
          </div>
        </div>
      `);
  }

  // If we found accordion items, wrap them all in a single container
  if (accordionItems.length > 0) {
    var accordionWrapper = `
         <div class="hh-accordion hh-accordion--light my-5">
            <div class="row">
               <div class="col-lg-10 mx-auto">
                  ${accordionItems.join("")}
               </div>
            </div>
         </div>
      `;

    // Replace the first accordion with the wrapper containing all items
    html = html.replace(
      /\[accordion\s+title="[^"]+"\][\s\S]*?\[\/accordion\]/,
      accordionWrapper,
    );

    // Remove any remaining accordion shortcodes
    html = html.replace(
      /\[accordion\s+title="[^"]+"\][\s\S]*?\[\/accordion\]/g,
      "",
    );
  }

  // Clean up any remaining <p> tags that might wrap the accordion wrapper
  html = html.replace(
    /<p[^>]*>\s*(<div class="accordion-wrapper"[\s\S]*?<\/div>)\s*<\/p>/gi,
    "$1",
  );

  // --- 5) Replace [gallery images="..."] with Swiper gallery ---

  var galleryRe = /\[gallery\s+images="([^"]+)"\s*\]/gi;
  html = html.replace(galleryRe, function (_, imagesList) {
    var images = imagesList.split(",").map(function (img) {
      return img.trim();
    });
    var galleryId = "gallery-" + Math.random().toString(36).substr(2, 9);

    if (images.length === 0) return "";

    // Generate main slider slides
    var mainSlides = images
      .map(function (image, index) {
        return `<div class="swiper-slide"><img src="${image}" alt="Gallery image ${index + 1}" class="w-100 h-auto" style="object-fit: contain;"></div>`;
      })
      .join("");

    // Generate thumbnail slides
    var thumbSlides = images
      .map(function (image, index) {
        return `<div class="swiper-slide"><img src="${image}" alt="Thumbnail ${index + 1}" class="w-100 h-auto" style="object-fit: contain;"></div>`;
      })
      .join("");

    return `
        <div class="image-gallery my-5" id="${galleryId}">
          <div class="row">
            <div class="col-lg-8 mx-auto">
              <!-- Main Swiper -->
              <div class="gallery-main overflow-hidden mb-2 position-relative border-rounded-stnd" data-gallery-main="${galleryId}">
                <div class="swiper-wrapper">
                  ${mainSlides}
                </div>
                <div class="swiper-next-fixed"><svg class="feather feather-chevron-right" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="9 18 15 12 9 6"/></svg></div>
                <div class="swiper-prev-fixed"><svg class="feather feather-chevron-left" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="15 18 9 12 15 6"/></svg></div>
              </div>
              
              <!-- Thumbnail Swiper -->
              <div class="gallery-thumbs overflow-hidden" data-gallery-thumbs="${galleryId}">
                <div class="swiper-wrapper">
                  ${thumbSlides}
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
  });

  // --- 4) Replace [product product_handle="..."] with placeholders (supports multiples) ---
  var productRe = /\[product\s+product_handle="([^"]+)"\s*\]/gi;
  html = html.replace(productRe, function (_, handle) {
    return (
      '<span class="shortcode-product" data-product-handle="' +
      handle.replace(/"/g, "&quot;") +
      '"></span>'
    );
  });

  // Commit transformed HTML back to the DOM
  root.innerHTML = html;

  // --- 5) Hydrate PRODUCT placeholders from /products/{handle}.js ---
  var placeholders = Array.prototype.slice.call(
    root.querySelectorAll(".shortcode-product"),
  );
  if (!placeholders.length) return;

  var cache = {};
  var handles = Array.from(
    new Set(
      placeholders.map(function (el) {
        return el.getAttribute("data-product-handle");
      }),
    ),
  );

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin",
    })
      .then(function (r) {
        if (!r.ok) throw new Error("Product not found: " + handle);
        return r.json();
      })
      .then(function (json) {
        cache[handle] = json;
        return json;
      })
      .catch(function (err) {
        console.warn(err);
        return null;
      });
  }

  function stripHTML(s) {
    var tmp = document.createElement("div");
    tmp.innerHTML = s || "";
    return (tmp.textContent || tmp.innerText || "").trim();
  }

  function renderProductBlock(p) {
    var productUrl = "/products/" + p.handle; // change to absolute if needed
    var image = p.images && p.images[0] ? p.images[0] : p.featured_image || "";
    var title = p.title || "";
    var desc = stripHTML(p.description).substring(0, 240);

    return `
        <section class="article-hero mb-5">
          <div class="row">
            <div class="col-11 col-lg-10 mx-auto border-rounded-stnd border--grey_01 p-3 p-md-4">
              <a href="${productUrl}" class="text-decoration-none text-dark">
                <div class="row">
                  <div class="col-md-3 d-flex align-items-center justify-content-end">
                    <img class="border-rounded-small mb-3 mb-md-0" 
                         width="100" 
                         height="100" 
                         style="max-width: 300px; width: 100%;" 
                         src="${image}" 
                         alt="${title.replace(/"/g, "&quot;")}">
                  </div>
                  <div class="col-md-6 d-flex flex-column justify-content-center">
                    <p class="strong mb-1">${title}</p>
                    <p class="mb-1">${desc}</p>
                  </div>
                  <div class="col-md-2 d-flex align-items-center justify-content-center">
                    <svg style="width: 100%; max-width: 40px;" 
                         class="my-2 mx-md-0" 
                         width="25" 
                         height="20" 
                         viewBox="0 0 24 16" 
                         fill="none" 
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 8H16M16 8L9 2M16 8L9 14" 
                            stroke="#FF6B35" 
                            stroke-width="2" 
                            stroke-linecap="round" 
                            stroke-linejoin="round"></path>
                    </svg>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </section>
      `;
  }

  Promise.all(handles.map(fetchProduct)).then(function () {
    placeholders.forEach(function (el) {
      var handle = el.getAttribute("data-product-handle");
      var data = cache[handle];
      if (!data) {
        el.outerHTML =
          "<!-- product shortcode failed for handle: " + handle + " -->";
      } else {
        el.outerHTML = renderProductBlock(data);
      }
    });
  });
};

// --- 6) Initialize Swiper galleries ---
// check main.js
